import { getConfig } from '@/config/runtimeConfig';

export default {
  saveLayerOpen: () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'save_layer_open',
    });
  },
  linkInbound: ({ linkUrl = '', linkType }) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'link_inbound',
      link_inbound: {
        link_domain: getConfig().pxcPortalUrl, // phoenixcontact.com
        link_url: linkUrl,
        type: linkType, // i.e. 'Login | Product Category Page | My Page ', 'contact support'
      },
    });
  },
  configureMarkingEditorSave: ({ articleNumber, projectName }) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'configurator_save',
      configurator_save: {
        article_number: articleNumber, // Article Nr. of original product
        selection: projectName, // Project Name
        configurator_name: 'Marking',
      },
    });
  },
};
